module.exports = __webpack_public_path__ + "img/gw-logo.c716d5a8.png";